import type { SignalsRoutingParams } from "app/pages/sales-intelligence/sub-modules/signals/types";
import type { StateParamsDeclaration } from "app/pages/sales-intelligence/types/routing";

export const signalsRoutingParams: StateParamsDeclaration<SignalsRoutingParams> = {
    digestDate: { dynamic: true },
    digestType: { dynamic: true },
    signalId: { dynamic: true },
    signalSubType: { dynamic: true },
    template: { dynamic: true },
    domain: { dynamic: true },
};

export const signalsRoutingParamsToClear = {
    digestType: undefined,
    digestDate: undefined,
    signalId: undefined,
    signalSubType: undefined,
    template: undefined,
    domain: undefined,
};
